import {
  APPS_FETCH_SUCCEEDED,
  APP_ADD_SUCCEEDED,
  APP_ADD_FAILED,
  APP_ADD_REQUESTED
} from '../actions/appActions';

const defaultState = {
  error: null,
  adding: false,
  loading: true,
  list: [],
  sortedList: []
};

export default function(state = defaultState, { type, apps, payload, error }) {
  switch (type) {
    case APPS_FETCH_SUCCEEDED:
      return {
        ...state,
        loading: false,
        list: apps,
        sortedList: apps.sort(
          (a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0)
        )
      };
    case APP_ADD_REQUESTED:
      return {
        ...state,
        adding: true
      };
    case APP_ADD_SUCCEEDED:
      return {
        ...state,
        adding: false
      };
    case APP_ADD_FAILED:
      return {
        ...state,
        error,
        adding: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/appsReducer.js